module.exports = __webpack_public_path__ + "static/media/Export Blue.fbc01f81.svg";